import get from 'lodash/get';
import { applicationTypes } from 'aurora-utils/constants';
import * as types from './constants';

const initialState = {
  applicationType: applicationTypes.ADD_EMPLOYEE,
  applicationId: null,
  application: null,
  form: {},
  documents: [],
  currentStep: 1,
  loading: false,
  error: null,
  employeeList: null,
  searchList: null,
  employeeDetail: {},
  employeeDetailDTO: {},
  permissionDTO: {},
  propertyForm: {
    propertyAdded: [],
    propertyRemoved: [],
    prermisionAdded: [],
    prermisionRemoved: [],
  },
  propertiesList: [],
  totalPages: 0,
  page: 0,
  size: 5,
  editSuccess: false,
  applicationNumber: null,
  selectedPermissions: [],
};

function employeeReducer(state = initialState, action = {}) {
  switch (action.type) {
    case types.EMPLOYEE_OPERATION_START:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.EMPLOYEE_OPERATION_END:
      return {
        ...state,
        loading: false,
        error: get(action.payload, 'error', 'oops_something_went_wrong'),
      };
    case types.UPDATE_EMPLOYEE_FORM:
      return {
        ...state,
        form: get(action.payload, 'data'),
      };
    case types.CHANGE_EMPLOYEE_WORKFLOW_STEP:
      return {
        ...state,
        currentStep: get(action.payload, 'step', 1),
      };
    case types.DISCARD_EMPLOYEE_APPLICATION:
      return {
        ...initialState,
      };
    case types.ADD_TO_EMPLOYEE_ERROR:
      return {
        ...state,
        loading: false,
        error: get(action.payload, 'message', 'oops_something_went_wrong'),
      };
    case types.INITIATE_EMPLOYEE_APPLICATION:
      return {
        ...state,
        loading: false,
        error: null,
        application: get(action.payload, 'application.result'),
        applicationId: get(action.payload, 'application.result.id'),
        applicationNumber: get(action.payload, 'application.result.applicationNumber'),
      };
    case types.FETCH_EMPLOYEE_USER: {
      const userData = get(action.payload, 'user.result');
      return {
        ...state,
        loading: false,
        error: null,
        form: {
          ...state.form,
          userData,
          email: userData?.email,
          phoneNumber: userData?.phoneNumber,
        },
      };
    }
    case types.SAVE_EMPLOYEE_INFO:
      return {
        ...state,
        loading: false,
        error: null,
        currentStep: state.currentStep + 1,
      };
    case types.ADD_EMPLOYEE_PROPERTIES:
      return {
        ...state,
        loading: false,
        error: null,
        form: {
          ...state.form,
          properties: get(action.payload, 'uploadedProperties.result', {}),
        },
      };
    case types.REMOVE_EMPLOYEE_PROPERY:
      return {
        ...state,
        loading: false,
        error: null,
        form: {
          ...state.form,
          properties: get(action.payload, 'uploadedProperties.result', {}),
        },
      };
    case types.FETCH_EMPLOYEE_LIST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.FETCH_EMPLOYEE_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        employeeList: get(action.payload, 'employees'),
      };
    case types.FETCH_EMPLOYEE_LIST_ERROR:
      return {
        ...state,
        loading: false,
        employeeList: null,
        error: get(action.payload, 'error'),
      };
    case types.FETCH_EMPLOYEE_PROPERTIES_SUCCESS:
      return {
        ...state,
        loading: false,
        page: get(action.payload, 'page'),
        propertiesList: get(action.payload, 'properties'),
      };
    case types.DELETE_EMPLOYEE:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.DEACTIVATE_EMPLOYEE_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case types.REACTIVATE_EMPLOYEE_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case types.DELETE_EMPLOYEE_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case types.SEARCH_EMPLOYEE_LIST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.SEARCH_EMPLOYEE_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        searchList: get(action.payload, 'searchList'),
      };
    case types.SEARCH_EMPLOYEE_LIST_ERROR:
      return {
        ...state,
        loading: false,
        searchList: null,
        error: get(action.payload, 'error'),
      };
    case types.FETCH_EMPLOYEE_PERMISSIONS:
      return {
        ...state,
        loading: false,
        permissionList: get(action.payload, 'permissions.result.groupPermissions', []),
      };
    case types.UPLOAD_EMPLOYEE_DOCUMENT:
      return {
        ...state,
        loading: false,
        documents: [...state.documents, get(action.payload, 'document.result', [])],
      };
    case types.DELETE_EMPLOYEE_DOCUMENT:
      return {
        ...state,
        loading: false,
        documents: get(action.payload, 'newDocuments', []),
      };
    case types.FETCH_EMPLOYEE_APPLICATION:
      return {
        ...state,
        loading: false,
        application: get(action.payload, 'application.result', null),
        documents: get(action.payload, 'documents.result', []),
      };
    case types.FETCH_EMPLOYEE_DETAIL_SUCCESS:
      return {
        ...state,
        loading: false,
        totalPages: get(action.payload, 'pages'),
        employeeDetail: get(action.payload, 'employee'),
        employeeDetailDTO: get(action.payload, 'employee.employeeDetailDTO'),
        permissionDTO: get(action.payload, 'employee.permissionDTO'),
        selectedPermissions: get(action.payload, 'employee.permissionIds'),
      };
    case types.FINAL_EMPLOYEE_SAVE_SUCCESS:
      return {
        ...state,
        loading: false,
        editSuccess: true,
      };
    case types.DOWNLOAD_EMPLOYE_DOCUMENT:
      return {
        ...state,
        loading: false,
        error: null,
      };
    case types.CHECKOUT_EMPLOYE_FORM:
      return {
        ...initialState,
      };
    case types.EDIT_SUCCESS_FALSE: {
      return {
        ...state,
        editSuccess: false,
      };
    }
    case types.UPDATE_SELECTED_PERMISSION:
      return {
        ...state,
        selectedPermissions: action.payload,
      };
    case types.UPDATE_EMPLOYEE_DETAIL:
      return {
        ...state,
        employeeDetailDTO: {
          ...state?.employeeDetailDTO,
          [action?.payload?.key]: action?.payload?.value,
        },
      };
    case types.EMPLOYEE_CLEAR_ERROR:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
}

export default employeeReducer;
